import { useEffect, useState } from 'react';
import {
  IconButton,
  Input,
  InputAdornment,
  Typography,
} from '@mui/material';
import {
  Close as CloseIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { useDebounce } from '../../../utils/ReactUtil';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './StudentSearchForm.scss';

const defaultProps = {
  onKeywordChange: () => { },
  title: 'SEARCH YOUR STUDENTS',
  placeholder: 'Student Name',
};

const StudentSearchForm = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { onKeywordChange, title, placeholder } = mergedProps;
  const [keyword, setKeyword] = useState('');
  const debouncedKeywordValue = useDebounce(keyword, 600);

  const handleTextChange = (event) => {
    setKeyword(event.target.value);
  };

  const handleClearKeywordClick = () => {
    setKeyword('');
  };

  useEffect(() => {
    onKeywordChange(debouncedKeywordValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedKeywordValue]);

  return (
    <div className='student-search-form'>
      <Typography variant='subtitle2'>
        {title}
      </Typography>
      <Input
        type='text'
        data-test='student-search-input'
        placeholder={placeholder}
        onChange={handleTextChange}
        variant='outlined'
        value={keyword || ''}
        className='input-field'
        inputProps={{
          'data-test': 'search-student-input',
          'data-dd-privacy': 'mask',
        }}
        endAdornment={
          keyword ? (
            <InputAdornment position='end' className='clear-keyword-button'>
              <IconButton
                aria-label='Clear keyword'
                onClick={handleClearKeywordClick}
              >
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          ) : (
            <InputAdornment position='end'>
              <SearchIcon className='search-icon' />
            </InputAdornment>
          )
        }
      />
    </div>
  );
};

export default StudentSearchForm;
